import React, { useEffect, useState } from 'react';
import moment from 'moment';
import Table from '../../../shared/table';
import { useAccountManagementDetailsMutation, useDownloadsAccountDetailsMutation } from '../../../store/chatbox/chatboxApi';
import { IPaginationPayload } from '../../../interfaces/shared/IPaginationPayload';
import Loading from '../../../shared/Loading';

const tableColumns = [
    'Timestamp',
    'User',
    'Query',
    'Document',
    'Client',
    'Agent',
    'Rating',
];

const QueriesTable = ({
	hotelId
}: {
	hotelId: string
}) => {
    const [paginationState, setPaginationState] = useState<IPaginationPayload>({
        pageNumber: 1,
        pageSize: 10,
        filters: 'all',
    });
    const [accountManagementDetails, { data }] =
        useAccountManagementDetailsMutation();

	const [downloadDetails, {isLoading: isDownloadLoading}] = useDownloadsAccountDetailsMutation();

    const getAccountDetails = async () => {
        try {
            await accountManagementDetails({
                ...paginationState,
                hotelId
            }).unwrap();
        } catch (e) {
            console.error({ e });
        }
    };

    useEffect(() => {
        getAccountDetails();
    }, [paginationState, hotelId]);

	const handleDownload = async () => {
		try {
			const res = await downloadDetails({
				hotelId
			}).unwrap();
			const { excelLink } = res.data;
            const response = await fetch(excelLink);
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = url;
            a.download = `hotel-details.xlsx`; 
            document.body.appendChild(a);
            a.click();
            a.remove();

            window.URL.revokeObjectURL(url);

		} catch (e) {
			console.error({e})
		}
	}

    const rows = data?.data.elements || [];

    return (
        <>
            <div className="flex flex-wrap items-center my-4">
                <h4 className="px-2 text-sm font-semibold">
                    Showing {data?.data.page.totalElements} queries
                </h4>
                <button
                    className="bg-gray-800 flex flex-row items-center px-5 py-1 text-white ml-auto border border-gray-200 rounded-lg"
					onClick={handleDownload}
                    type="button">
                    {isDownloadLoading && <Loading />}
                    Export data
                    <img
                        src="/assets/chat/export.svg"
                        className="ml-3"
                        alt="export"
                    />
                </button>
            </div>
            <Table
                columns={tableColumns}
                paginationData={data?.data.page}
                setPaginationState={setPaginationState}
                containerStyle="border p-2 rounded-xl">
                {rows?.length > 0 &&
                    rows?.map((row, idx: number) => {
                        return (
                            <tr
                                key={idx}
                                className="bg-white dark:bg-black border-b hover:bg-gray-50 text-black dark:text-white text-sm">
                                <td className="px-6 py-4">
                                    {moment(row?.createdAt).format(
                                        'DD-MM-YYYY hh:mm:ss',
                                    )}{' '}
                                </td>
                                <td className="px-6 py-4">
                                    {' '}
                                    {row.userInfo.email}{' '}
                                </td>
                                <td className="px-6 py-4"> {row.query} </td>
                                <td className="px-6 py-4">
                                    {' '}
                                    {row.sources.map((source) => (
                                        <div
                                            key={source}
                                            className="bg-gray-100 dark:bg-gray-800 dark:text-white p-1 rounded">
                                            {source}
                                        </div>
                                    ))}{' '}
                                </td>
                                <td className="px-6 py-4">
                                    {' '}
                                    {row.hotelInfo.name}{' '}
                                </td>
                                <td className="px-6 py-4">
                                    {' '}
                                    {row.agent.name}{' '}
                                </td>
                                <td className="px-6 py-4">
                                    {row.liked ? (
                                        <img
                                            alt="liked"
                                            src="/assets/chat/liked.svg"
                                        />
                                    ) : (
                                        <></>
                                    )}
                                    {row.disliked ? (
                                        <img
                                            alt="liked"
                                            src="/assets/chat/disliked.svg"
                                        />
                                    ) : (
                                        <></>
                                    )}
                                </td>
                            </tr>
                        );
                    })}
            </Table>
        </>
    );
};

export default QueriesTable;
